// extracted by mini-css-extract-plugin
module.exports = {"CommingSoon":"CommingSoon_CommingSoon__Jr3Ht"};